import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';
import { MatTableDataSource } from '@angular/material/table';
import { AddFromListDialogData } from './tag-objects-dialog.data';

export interface IDeployedPackagesTable {
    name: string;
    type: string;
}

@Component({
    selector : 'tag-objects-dialog',
    template: require('./tag-objects-dialog.component.html'),
    styles: [require('./tag-objects-dialog.component.scss')]
})


export class TagObjectDialogComponent {
    public dataSource = new MatTableDataSource<IDeployedPackagesTable>([]);
    public displayedColumns = ['Name', 'Type'];

    constructor(@Inject(MAT_DIALOG_DATA) public data: AddFromListDialogData) {
        const table = [];
        data.elements.forEach((item) => {
            table.push({
                name: item.name,
                type: item.type
            });
        });
        this.dataSource.data = table;
    }


}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/tag-objects-dialog/tag-objects-dialog.component.ts